import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

import { MenuComponent } from './menu.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuRouterItemComponent } from './menu-router-item/menu-router-item.component';
import { MenuSeparatorItemComponent } from './menu-separator-item/menu-separator-item.component';

@NgModule({
  declarations: [
    MenuComponent,
    MenuItemComponent,
    MenuRouterItemComponent,
    MenuSeparatorItemComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  exports: [
    MenuComponent,
    MenuItemComponent,
    MenuRouterItemComponent,
    MenuSeparatorItemComponent,
  ],
})
export class MenuModule {}
